import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {
    Header,
    Footer,
    DisclaimerContractedFindUser,
    DisclaimerContractedUpdateUser
} from "./components";
import "react-datepicker/dist/react-datepicker.css";
import { Col, InputGroup, Row, Toast } from "react-bootstrap";
import {
    emailValidation,
    emailVerifyMatch,
    userNameValidation
} from "validation";
import { QuestionCircle } from "react-bootstrap-icons";
import axios from "axios";
import { analytics } from "analytics";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const FPFindUserContracted = () => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const [user, setUser] = useState({
        tin: "",
        lastName: "",
        identifier: "",
        saidCode: "",
        email: "",
        isDuplicate: false,
        newUserName: "",
        completedFindUser: false,
        userName: "",
        completedUpdateUser: false
    });

    const searchParams = new URLSearchParams(window.location.search);
    const reqApp = searchParams.get("app");

    const [errors, setErrors] = useState({
        tin: "",
        lastName: "",
        identifier: "",
        saidCode: "",
        email: ""
    });

    useEffect(() => {
        analytics();
    }, []);

    useEffect(() => {
        document.title = "Username Recovery";
    }, []);

    useEffect(() => {
        if (!user.completedFindUser) {
            for (const element of ["tin", "saidCode", "lastName"]) {
                const fieldName = element;
                if (!user[fieldName]) {
                    setSubmitDisabled(true);
                    return;
                }
            }

            const errorFields = Object.keys(errors);
            for (const element of errorFields) {
                const fieldName = element;
                if (errors[fieldName] !== "") {
                    setSubmitDisabled(true);
                    return;
                }
            }
        }
        if (user.isDuplicate) {
            for (const element of ["newUserName"]) {
                const fieldName = element;
                if (!user[fieldName]) {
                    setSubmitDisabled(true);
                    return;
                }
            }

            const errorFields = Object.keys(errors);
            for (const element of errorFields) {
                const fieldName = element;
                if (errors[fieldName] !== "") {
                    setSubmitDisabled(true);
                    return;
                }
            }
        }
    }, [user, errors]);

    const [toastMessage, setToastMessage] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [submitting, setsubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const payload = { [name]: value };
        setUser((prev) => ({ ...prev, ...payload }));
    };

    const handleUpdateUserName = async (e) => {
        e.preventDefault();
        let errMsg = "";
        //const test = JSON.stringify(payload);
        setsubmitting(true);

        const payload = { userId: user.newUserName, ...user };
        try {
            const res = await axios({
                method: "POST",
                url: "/life/enroll/api/userprofile/fp/userName/update",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload)
            }).catch(function (err) {
                if (err.response) {
                    errMsg = err.response?.data?.error?.message;
                    console.log(
                        err.response?.data?.error?.message ||
                            err.response?.data ||
                            "Something went wrong.  Please try again later."
                    );
                    setToastMessage(
                        errMsg ||
                            "Something went wrong.  Please try again later."
                    );
                } else if (err.request) {
                    console.log(err.request);
                } else {
                    console.log("Error", err.message);
                }
            });
            if (res.status === 200) {
                setUser((prev) => ({
                    ...prev,
                    ...{ completedUpdateUser: true }
                }));
            }
        } catch (error) {
            setToastMessage(
                errMsg ||
                    error.response?.data?.errorMessage ||
                    "Something went wrong. Please try again later."
            );
        }
        setsubmitting(false);
    };

    const handleFindUserName = async (e) => {
        e.preventDefault();
        let errMsg = "";
        setsubmitting(true);

        const payload = user;
        try {
            const res = await axios({
                method: "POST",
                url: "/life/enroll/api/userprofile/fp/contracted/userName/find",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload)
            }).catch(function (err) {
                if (err.response) {
                    errMsg = err.response?.data?.error?.message;
                    console.log(
                        err.response?.data?.error?.message ||
                            err.response?.data ||
                            "Something went wrong. Please try again later."
                    );
                    setToastMessage(
                        errMsg ||
                            "Something went wrong.  Please try again later."
                    );
                } else if (err.request) {
                    console.log(err.request);
                } else {
                    console.log("Error", err.message);
                }
            });
            if (res.status === 200) {
                console.log(res);
                let isDuplicate = false;
                if (res.data.data.isDuplicate) {
                    isDuplicate = res.data.data.isDuplicate;
                }

                user.completedFindUser = true;
                user.isDuplicate = isDuplicate;
                user.identifier = res.data.data.identifier;
                user.userName = res.data.data.userId;
                setSubmitDisabled(true);
            }
        } catch (error) {
            setToastMessage(
                errMsg ||
                    error.response?.data?.errorMessage ||
                    "Something went wrong. Please try again later."
            );
        }
        setsubmitting(false);
    };

    const handleLogin = async (e) => {
        let identifier = user.identifier;
        let isUserNameUpdated = "N";
        if (user.completedUpdateUser) {
            identifier = user.newUserName;
            isUserNameUpdated = "Y";
        }
        window.location.href = `/life/enroll/api/authorize?login_hint=${identifier}&app=${reqApp}&updated=${isUserNameUpdated}`;
    };

    const handleBlur = async (e) => {
        const { name, value } = e.target;
        let errorMessage = "";

        if (name === "policyNumber") {
            if (value.length === 0 && !user.saidCode) {
                errorMessage = "Policy Number or Agent Code must be entered";
            } else if (/[^a-zA-Z0-9*]/g.test(value)) {
                errorMessage =
                    "Policy Number must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
                errors.saidCode = "";
            }
        }
        if (name === "saidCode") {
            if (value.length === 0) {
                errorMessage = "Producer Code must be entered";
            } else if (/[^a-zA-Z0-9*]/g.test(value)) {
                errorMessage =
                    "Producer Code must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
                errors.policyNumber = "";
            }
        }
        if (name === "dob") {
            if (value.length === 0) {
                errorMessage = "Insured's Date of Birth must be entered";
            } else {
                errorMessage = "";
            }
        }
        if (name === "trustName") {
            if (user.tinType === "T") {
                if (value) {
                    if (/[^[a-zA-Z0-9\s()&,''-]/.test(value)) {
                        errorMessage =
                            "Trust/Organization entered is not valid";
                    }
                }
            }
        }
        if (name === "tin") {
            const valid = true;

            if (value.length === 0) {
                errorMessage = "Tax ID is required.";
            } else {
                errorMessage = valid ? "" : "Please enter a valid Tax ID.";
            }
        }

        if (name === "isCheckedFindMyPolicy") {
            errorMessage = e.target.checked
                ? ""
                : "Agree to the terms and conditions";
        }

        if (name === "tinType") {
            errorMessage = e.target.value !== "" ? "" : "Select SSN or TIN";
        }

        if (name === "firstName") {
            if (value.length === 0) {
                errorMessage = "First name is required.";
            } else if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "Names can only include letters and standard punctuation.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "middleName") {
            if (/[^a-zA-Z ]/.test(value)) {
                errorMessage = "Please use letters only for this field.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "suffix") {
            if (/[^a-zA-Z ]/.test(value)) {
                errorMessage = "Please use letters only for this field.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "lastName") {
            if (value.length === 0) {
                errorMessage = "Last name is required.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "email") {
            const emailValid = emailValidation(value);
            if (value.length === 0) {
                errorMessage = "Please enter your email address.";
            } else {
                errorMessage = emailValid
                    ? ""
                    : "Please enter a valid email address (e.g., name@example.com).";
            }
        }

        if (name === "verifyEmail") {
            const emailConfirmValid = emailValidation(value);

            if (value.length === 0) {
                errorMessage = " Please confirm your email address.";
            } else {
                errorMessage = emailConfirmValid
                    ? ""
                    : "Email addresses do not match. Please re-enter.";
            }
            if (!errorMessage) {
                errorMessage = emailVerifyMatch(user.email, value)
                    ? ""
                    : "Email addresses do not match. Please re-enter.";
            }
        }

        if (name === "phoneNumber") {
            errorMessage =
                value.length < 14 ? "Enter a valid 10 digit phone number" : "";
        }
        if (name === "verifyPhoneNumber") {
            errorMessage =
                value.length < 14 ? "Enter a valid 10 digit phone number" : "";
            errorMessage =
                user.phoneNumber !== value
                    ? "Phone number do not match"
                    : errorMessage;
        }
        if (name === "password") {
            errorMessage =
                value.length < 6
                    ? "Enter a valid password above 6 characters"
                    : "";
        }
        if (name === "confirmPassword") {
            errorMessage =
                user.password !== value
                    ? "Password do not match"
                    : errorMessage;
        }
        if (name === "zipCode") {
            if (value.length < 5) {
                errorMessage =
                    "Enter the five digit ZIP code of your primary residence";
            }
        }

        if (name === "state") {
            if (user.state) {
                errorMessage = user.state !== "" ? "" : "Select State";
            } else {
                errorMessage = "Select State";
            }
        }

        if (name === "role") {
            if (user.role) {
                errorMessage =
                    user.role !== "" ? "" : "Please select your role.";
            } else {
                errorMessage = "Please select your role.";
            }
        }

        if (name === "newUserName") {
            const validUserName = userNameValidation(value);
            const emailValid = emailValidation(value);
            const tooShortOrLongUserName =
                value.length < 5 || value.length > 15;
            if (emailValid && !errorMessage) {
                errorMessage = "Do not enter an email in the Username field.";
            }
            if (value) {
                if (value.length === 0) {
                    errorMessage = "Please enter a username.";
                }
            } else {
                errorMessage = "Please enter a username.";
            }
            if (value.indexOf(" ") > -1 && !errorMessage) {
                errorMessage = "Username name should not contain space.";
            }
            if (/[^a-zA-Z0-9-_. ]/.test(value) && !errorMessage) {
                errorMessage =
                    "Username can only include letters, numbers, and underscores.";
            }
            if (validUserName) {
                errorMessage = "";
            } else if (tooShortOrLongUserName && !errorMessage) {
                errorMessage =
                    "Username must be at least 5 characters and no more than 20 characters.";
            }
        }
        if (errorMessage !== "") {
            setSubmitDisabled(true);
        } else {
            setSubmitDisabled(false);
        }
        setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    };

    const closeToast = () => {
        setToastMessage("");
    };

    return (
        <>
            {toastMessage !== "" && (
                <Toast onClose={closeToast} className="toast-cont">
                    <Toast.Header>
                        <strong className="me-auto">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: toastMessage
                                }}
                            ></div>
                        </strong>
                    </Toast.Header>
                </Toast>
            )}
            <Header />
            {!user.completedFindUser && (
                <div className="mainMyAccount">
                    <h1 className="heading">Recover Username</h1>
                    <br />
                    <div>
                        Enter the information associated to your Life Insurance
                        contract with Pacific Life. If we find your profile, we
                        will email your Username to you.
                    </div>
                    <Form
                        onKeyDown={(e) => {
                            if (e.key === "Enter") e.preventDefault();
                        }}
                    >
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>SSN or TIN</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            name="tin"
                                            autoComplete="off"
                                            maxLength={9}
                                            value={user.tin}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            type={
                                                showPassword
                                                    ? "text"
                                                    : "password"
                                            }
                                        />
                                        <InputGroup.Text
                                            onClick={togglePasswordVisibility}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {showPassword ? (
                                                <EyeSlash />
                                            ) : (
                                                <Eye />
                                            )}
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                                <span className="validation-error-message">
                                    {errors.tin}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Label>
                                    Producer Code (SAID or PCN)
                                    <QuestionCircle
                                        tabIndex="-1"
                                        className="iconClass"
                                        data-tip="A 5 digit contract code provided by Pacific Life; Code must be associated to the tax ID provided above."
                                    />
                                </Form.Label>
                                <Form.Control
                                    name="saidCode"
                                    autoComplete="off"
                                    maxLength={5}
                                    value={user.saidCode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.saidCode}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    name="lastName"
                                    autoComplete="off"
                                    maxLength={25}
                                    value={user.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.lastName}
                                </span>
                            </Col>
                        </Row>

                        <div className="buttons-myaccount">
                            <Button
                                variant="primary"
                                type="submit"
                                onClick={handleFindUserName}
                                data-track="analytics"
                                disabled={submitDisabled || submitting}
                            >
                                {submitting ? "Processing" : "Find My Username"}
                            </Button>
                        </div>
                    </Form>
                    <DisclaimerContractedFindUser />
                </div>
            )}
            {user.completedFindUser && !user.isDuplicate && (
                <div className="mainMyAccount">
                    <h1 className="heading">Account Located</h1>
                    <div>
                        Your username starts with {user.userName}
                        <br />
                        We have sent the full username to your email.
                    </div>
                    <Form
                        onKeyDown={(e) => {
                            if (e.key === "Enter") e.preventDefault();
                        }}
                    >
                        <div className="buttons-myaccount">
                            <Button
                                variant="primary"
                                type="button"
                                onClick={handleLogin}
                                data-track="analytics"
                            >
                                Return To Login
                            </Button>
                        </div>
                    </Form>
                    <DisclaimerContractedFindUser />
                </div>
            )}
            {user.completedFindUser &&
                user.isDuplicate &&
                !user.completedUpdateUser && (
                    <div className="mainMyAccount">
                        <h1 className="heading">
                            Looks like your Username took a dive.
                            <br />
                            Time to create a new one!
                        </h1>
                        <div>
                            For account security, a new username is required
                            <br />
                            Please take a moment to create a new UserName that
                            meets our security requirements.
                            <br />
                            <br />
                            Requirements: <br />
                            <ul>
                                <li>Must be unique.</li>
                                <li>
                                    Must be between 5 and 20 alpha-numeric
                                    characters.
                                </li>
                                <li>
                                    Underscores and periods are permitted, but
                                    no other symbols or characters.
                                </li>
                                <li>Cannot be an email.</li>
                            </ul>
                        </div>

                        <Form
                            onKeyDown={(e) => {
                                if (e.key === "Enter") e.preventDefault();
                            }}
                        >
                            <Row>
                                <Col md={6}>
                                    <Form.Label>
                                        Enter a new Username
                                    </Form.Label>
                                    <Form.Control
                                        name="newUserName"
                                        autoComplete="off"
                                        maxLength={20}
                                        value={user.newUserName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <span className="validation-error-message">
                                        {errors.newUserName}
                                    </span>
                                </Col>
                            </Row>
                            <div className="buttons-myaccount">
                                <Button
                                    variant="primary"
                                    type="submit"
                                    onClick={handleUpdateUserName}
                                    data-track="analytics"
                                    disabled={submitDisabled || submitting}
                                >
                                    {submitting
                                        ? "Processing"
                                        : "Update My Username"}
                                </Button>
                            </div>
                        </Form>
                        <DisclaimerContractedUpdateUser />
                    </div>
                )}
            {user.completedFindUser &&
                user.isDuplicate &&
                user.completedUpdateUser && (
                    <div className="mainMyAccount">
                        <h1 className="heading">
                            Whale done. Your Username has been updated!
                            <br />
                        </h1>
                        <div>
                            Your new username is now active. Please update your
                            records.
                            <br />
                        </div>
                        <Form
                            onKeyDown={(e) => {
                                if (e.key === "Enter") e.preventDefault();
                            }}
                        >
                            <div className="buttons-myaccount">
                                <Button
                                    variant="primary"
                                    type="button"
                                    onClick={handleLogin}
                                    data-track="analytics"
                                >
                                    Return To Login
                                </Button>
                            </div>
                        </Form>
                        <DisclaimerContractedUpdateUser />
                    </div>
                )}
            <Footer />
        </>
    );
};

export default FPFindUserContracted;
